import { useEffect, useState } from "react";
import Modal from "./Modal";
import { useModal } from "../helpers/useModal";

import "../estilos/IM_Imagenes.css";

import ic_manual_primary from '../recGraficos/ic_manual_primary.png';
import ic_reloj from '../recGraficos/ic_reloj.png';
import ic_transparente from '../recGraficos/ic_transparente.png';

import { C_colorTextoSinInfo, C_fondoGrisSuperClaro, C_uniformeGrisOscuro, SEP_1 } from "../constantes/generales";
import { convertirHora, esformatoHoraDia, generarDiasSemana, reportarError, valorNumero } from "../helpers/funciones";
import { DndContext } from "@dnd-kit/core";
import Draggable from "./Draggable";
import Droppable from "./Droppable";

const nomClase="SelHorario_WB";

let horasI = {
    hInicial:"",
    hFinal:""
};


const SelHorario = ({txtHorario="", clickGenerico }) => {
  const [isOpenHorario, openHorario, closeHorario] = useModal(true);
  const [isOpenSelHora, openSelHora, closeSelHora] = useModal(false);

  const [clickAceptarUS, setClickAceptarUS] = useState(false);

  const [showDiasUS, setShowDiasUS] = useState([false,false,false,false,false,false,false]);
  const [errorDiasUS, setErrorDiasUS] = useState([true,true,true,true,true,true,true]);
  const [horasDiasUS, setHorasDiasUS] = useState([horasI,horasI,horasI,horasI,horasI,horasI,horasI]);

  const [diasSemanaUS, setDiasSemanaUS] = useState(["LUNES","MARTES","MIERCOLES","JUEVES","VIERNES","SABADO","DOMINGO"]);
  
  const [diaSelUS, setDiaSelUS] = useState(0);
  const [horaIFSelUS, setHoraIFSelUS] = useState(0);
  const [horaSelUS, setHoraSelUS] = useState(0);
  const [tipoHoraSelUS, setTipoHoraSelUS] = useState("");
  const [txtCentralUS, setTxtCentralUS] = useState("Seleccioner la hora...");
  const [txtErrorUS, setTxtErrorUS] = useState("");

  

    useEffect(() => {
      let nomFuncion="useEffect"; 

        try{
            
            let dHorario=generarDiasSemana(txtHorario);
            let tempHorario=[];

            let tempDias=JSON.parse(JSON.stringify(showDiasUS));
            let tempErrores=JSON.parse(JSON.stringify(errorDiasUS));

            for(let i=0;i<dHorario.length;i++){
                let registro=Object.assign({} , horasI);
                registro.hInicial=dHorario[i][1] === "00:00" ? "" : dHorario[i][1];
                registro.hFinal=dHorario[i][2] === "00:00" ? "" : dHorario[i][2];
                tempHorario.push(registro);
                tempErrores[i]=true;

                if(registro.hInicial!=="" || registro.hFinal!==""){
                    tempDias[i]=true;
                    if(registro.hInicial!=="" && registro.hFinal!=="") tempErrores[i]=false;
                }
            }

            setShowDiasUS(tempDias);
            setErrorDiasUS(tempErrores);
            setHorasDiasUS(tempHorario);
            openHorario();

            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }, []);


    const clickHorario = (donde, params=null) => {
        let nomFuncion="clickHorario"; 

        try{
            
            let e=null;
            let dia=0;

            if(donde!=="ACEPTAR_DEFINIR_HORARIO" && donde!=="BORRAR_HORA_ACTUAL"){
                e=params[0];
                dia=params[1];
            }

            let tempHorario=null;
            let tempErrores=null;
            
            switch(donde) {
 
                case "CLICK_CHECKBOX":     
                    let tempDias=JSON.parse(JSON.stringify(showDiasUS));

                    tempDias[dia]=e.target.checked;

                    setShowDiasUS(tempDias);                    
                         
                    break;     
                case "CLICK_HORA_INICIAL":
                    setTxtErrorUS("");
                    setHoraSelUS(0);
                    setTipoHoraSelUS("");
                    setDiaSelUS(dia);
                    setHoraIFSelUS(1);
                    openSelHora();
                             
                    break;                   
                case "CLICK_HORA_FINAL":
                    setTxtErrorUS("");
                    setHoraSelUS(0);
                    setTipoHoraSelUS("");
                    setDiaSelUS(dia);
                    setHoraIFSelUS(2);
                    openSelHora();
                             
                    break;   
                case "ACEPTAR_DEFINIR_HORARIO":

                    setClickAceptarUS(true);

                    let hayErrores=false;
                    let estaVacio=true;

                    let txtHorasTemp="";
                    let txtHorariosT="";

                    tempErrores=JSON.parse(JSON.stringify(errorDiasUS));

                    for(let i=0;i<showDiasUS.length;i++){
                        tempErrores[i]=false;
                        if(showDiasUS[i]){
                            if(horasDiasUS[i].hInicial==="" || horasDiasUS[i].hFinal===""){
                                tempErrores[i]=true;
                                hayErrores=true;
                            }
                            else{
                                estaVacio=false;
                                let txtDia="";
                                if(txtHorariosT!==("")) txtHorariosT=txtHorariosT + "\n";
                                if(txtHorasTemp!==("")) txtHorasTemp=txtHorasTemp + SEP_1;

                                if(i===0) txtDia="LUNES ";
                                if(i===1) txtDia="MARTES ";
                                if(i===2) txtDia="MIERCOLES ";
                                if(i===3) txtDia="JUEVES ";
                                if(i===4) txtDia="VIERNES ";
                                if(i===5) txtDia="SABADO ";
                                if(i===6) txtDia="DOMINGO ";

                                let txtDiaCorto=txtDia.substring(0,2) + " ";

                                 txtHorariosT=txtHorariosT + txtDia + esformatoHoraDia(convertirHora(convertirHora(horasDiasUS[i].hInicial,"NORMAL"),"MILITAR")) + " a " +
                                            esformatoHoraDia(convertirHora(convertirHora(horasDiasUS[i].hFinal,"NORMAL"),"MILITAR"));


                                txtHorasTemp=txtHorasTemp + txtDiaCorto + convertirHora(convertirHora(horasDiasUS[i].hInicial,"NORMAL"),"MILITAR") + "-" + convertirHora(convertirHora(horasDiasUS[i].hFinal,"NORMAL"),"MILITAR");
                                
                            }
                        }
                    }

                    setErrorDiasUS(tempErrores);

                    if(!hayErrores){
                        if(!estaVacio){
                            setTxtErrorUS("");
                            closeHorario();
                            clickGenerico("RECIBIR_HORARIO",[txtHorariosT,txtHorasTemp]);
                        }
                        else{
                            setTxtErrorUS("No se ha agregado ningún horario.")
                        }
                    }
                    
                             
                    break; 
                case "BORRAR_HORA_ACTUAL":
                    tempHorario=JSON.parse(JSON.stringify(horasDiasUS));
                    tempErrores=JSON.parse(JSON.stringify(errorDiasUS));
                    dia=diaSelUS;
                    tempErrores[dia]=false;
                                        
                    if(horaIFSelUS===1){
                        tempHorario[dia].hInicial="";
                        tempErrores[dia]=true;
                    }
                    else if(horaIFSelUS===2){
                        tempHorario[dia].hFinal="";
                        tempErrores[dia]=true;
                    }

                    setErrorDiasUS(tempErrores);
                    setHorasDiasUS(tempHorario);
                    closeSelHora();
                    
                    break;
                default:
                    break;
            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }  
    
    const clickHora = (hora) => {
        let nomFuncion="clickHora"; 

        try{
            
            if(tipoHoraSelUS!==""){
                let tempHorario=JSON.parse(JSON.stringify(horasDiasUS));
                let tempErrores=JSON.parse(JSON.stringify(errorDiasUS));
                let dia=diaSelUS;

                tempErrores[dia]=true;

                let horaFinal=convertirHora(hora + " " + tipoHoraSelUS, "MILITAR");
                if(horaIFSelUS===1){
                    tempHorario[dia].hInicial=esformatoHoraDia(horaFinal);

                    if(tempHorario[dia].hFinal!=="") {
                        let horaI = valorNumero(convertirHora(convertirHora(tempHorario[dia].hInicial,"NORMAL"), "MILITAR"));
                        let horaF = valorNumero(convertirHora(convertirHora(tempHorario[dia].hFinal,"NORMAL"), "MILITAR"));

                        if (horaI >= horaF) tempHorario[dia].hFinal="";
                    }

                    if(tempHorario[dia].hInicial!=="" && tempHorario[dia].hFinal!=="") tempErrores[dia]=false;
                } 
                if(horaIFSelUS===2) {
                    tempHorario[dia].hFinal=esformatoHoraDia(horaFinal);

                    if(tempHorario[dia].hInicial!=="") {
                        let horaI = valorNumero(convertirHora(convertirHora(tempHorario[dia].hInicial,"NORMAL"), "MILITAR"));
                        let horaF = valorNumero(convertirHora(convertirHora(tempHorario[dia].hFinal,"NORMAL"), "MILITAR"));

                        if (horaI >= horaF) tempHorario[dia].hInicial="";
                    }

                    if(tempHorario[dia].hInicial!=="" && tempHorario[dia].hFinal!=="") tempErrores[dia]=false;
                }

                setErrorDiasUS(tempErrores);
                setHorasDiasUS(tempHorario);
                closeSelHora();
            }
            else{
                if(horaSelUS===hora){
                    setHoraSelUS(0);
                    setTxtCentralUS("Selecciones la hora");
                }
                else{
                    setHoraSelUS(hora);
                    setTxtCentralUS("Selecciones AM/PM");
                }
            }
           
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }  

    const clickTiempo = (tipoHora) => {
        let nomFuncion="clickHora"; 

        try{
            
    
           if(horaSelUS>0){
                let tempHorario=JSON.parse(JSON.stringify(horasDiasUS));
                let tempErrores=JSON.parse(JSON.stringify(errorDiasUS));
                let dia=diaSelUS;

                tempErrores[dia]=true;

                let horaFinal=convertirHora(horaSelUS + " " + tipoHora, "MILITAR");

                if(horaIFSelUS===1){
                    tempHorario[dia].hInicial=esformatoHoraDia(horaFinal);

                    if(tempHorario[dia].hFinal!=="") {
                        let horaI = valorNumero(convertirHora(convertirHora(tempHorario[dia].hInicial,"NORMAL"), "MILITAR"));
                        let horaF = valorNumero(convertirHora(convertirHora(tempHorario[dia].hFinal,"NORMAL"), "MILITAR"));

                        if (horaI >= horaF) tempHorario[dia].hFinal="";
                    }

                    if(tempHorario[dia].hInicial!=="" && tempHorario[dia].hFinal!=="") tempErrores[dia]=false;
                } 
                if(horaIFSelUS===2) {
                    tempHorario[dia].hFinal=esformatoHoraDia(horaFinal);

                    if(tempHorario[dia].hInicial!=="") {
                        let horaI = valorNumero(convertirHora(convertirHora(tempHorario[dia].hInicial,"NORMAL"), "MILITAR"));
                        let horaF = valorNumero(convertirHora(convertirHora(tempHorario[dia].hFinal,"NORMAL"), "MILITAR"));

                        if (horaI >= horaF) tempHorario[dia].hInicial="";
                    }

                    if(tempHorario[dia].hInicial!=="" && tempHorario[dia].hFinal!=="") tempErrores[dia]=false;
                }

                setErrorDiasUS(tempErrores);
                setHorasDiasUS(tempHorario);
                closeSelHora();
            }
            else{
                if(tipoHoraSelUS===tipoHora){
                    setTipoHoraSelUS("");
                    setTxtCentralUS("Selecciones la hora");
                }
                else{
                    setTipoHoraSelUS(tipoHora);
                    setTxtCentralUS("Selecciones la hora");
                }
            }
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }      

    const clickCerrar = () => {    
        closeHorario();
        clickGenerico("CERRAR_VENTANA_HORARIO");
    } 


    function handleDragEnd(event){
        let nomFuncion="handleDragEnd"; 

        try{

            if(event.active!==null && event.over!=null){
                let diaOrigen=event.active.id;
                let diaDestino=event.over.id;

                if(diaOrigen!==diaDestino){
                    let tempHorasDias=JSON.parse(JSON.stringify(horasDiasUS));
                    let tempErrores=JSON.parse(JSON.stringify(errorDiasUS));

                    tempHorasDias[diaDestino]=tempHorasDias[diaOrigen];
                    tempErrores[diaDestino]=tempErrores[diaOrigen];

                    setHorasDiasUS(tempHorasDias);
                    setErrorDiasUS(tempErrores);
                } 
            }
            
        
        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 
    }


  return (
    <>
    
            {isOpenHorario && (
                <Modal isOpen={isOpenHorario} closeModal={clickCerrar} titulo={"Definir Horario"}  isCancelable={false} clickAceptar={() => clickHorario("ACEPTAR_DEFINIR_HORARIO")} >
                <div style={{margin:"20px", minHeight:"300px", maxWidth:"400px"}}>                    
                    
                    <div style={{fontSize:"14px", color:C_uniformeGrisOscuro}}>
                        Seleccione los días y defina los horarios para cada día, teniendo en cuenta la hora de inicio y de inalización e partidos</div>
                    
                    <DndContext onDragEnd={handleDragEnd}>
                    <div style={{color:C_uniformeGrisOscuro}}>
                        <table width={"100%"} border={0}>
                            <tbody>
                                <tr style={{textAlign:"center", fontSize:"12px", fontWeight:"bold"}}>
                                    <td></td>
                                    <td width={"200px"}>
                                        <div className="TX_unaSolaLinea2" style={{display:"flex", flexWrap:"nowrap", alignItems:"center", paddingTop:"8px"}}>
                                            <div style={{flex:"1"}}>H Inicial</div><div style={{width:"10px"}}></div><div style={{flex:"1"}}>H Final</div>
                                            <div style={{paddingBlock:"4px", paddingInline:"8px"}}>
                                                <img className='IM_imgIcono24' src={ic_transparente} alt='' />
                                            </div>
                                        </div>                                        
                                    </td>
                                </tr>

                                {diasSemanaUS.map((reg,index) => (
                                <tr key={index}>
                                    <td>
                                        <label style={{display:"flex", alignItems:"center", flex:"1", justifyContent:"left", textAlign:"left", cursor:"pointer"}}>
                                            <input checked={showDiasUS[index]} type="checkbox" className="colorAccent" name="opcionMenu" onChange={(e)=> {clickHorario("CLICK_CHECKBOX",[e,index])}}/>
                                            <span style={{color:C_uniformeGrisOscuro, marginInline: "10px"}}>{reg}</span>
                                        </label>
                                    </td>
                                    <td style={{height:"32px"}}>
                                        {showDiasUS[index] && (
                                        <Droppable id={index} children={(
                                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                                <div style={{flex:"1"}}>
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", fontSize:"12px", color:C_uniformeGrisOscuro, textAlign:"center"}}>
                                                        <div style={{flex:"1", display:"flex", justifyContent:"center", alignItems:"center"}}>
                                                            <div className='IP_entradasPeq' style={{width: "45px", cursor:"pointer", display:"flex", justifyContent:"center", alignItems:"center", backgroundColor:C_fondoGrisSuperClaro}} onClick={(e) => {clickHorario("CLICK_HORA_INICIAL",[e,index])}}><span>{convertirHora(horasDiasUS[index].hInicial,"NORMAL")}</span></div>  
                                                        </div>
                                                        <div style={{width:"20px", textAlign:"center"}}>-</div>
                                                        <div style={{flex:"1", display:"flex", justifyContent:"center", alignItems:"center"}}>
                                                            <div className='IP_entradasPeq' style={{width: "45px", cursor:"pointer", display:"flex", justifyContent:"center", alignItems:"center", backgroundColor:C_fondoGrisSuperClaro}} onClick={(e) => {clickHorario("CLICK_HORA_FINAL",[e,index])}}><span>{convertirHora(horasDiasUS[index].hFinal,"NORMAL")}</span></div>  
                                                        </div>
                                                    </div>
                                                    {clickAceptarUS && errorDiasUS[index] && (<div className="TX_error" style={{fontSize:"12px", margin:"0", padding:"0"}}>{"Horas Obligatorias"}</div>)}
                                                </div>
                                                
                                                <div style={{paddingBlock:"4px", paddingInline:"8px"}}>
                                                    {!errorDiasUS[index] && (<Draggable id={index} children={(<img className='IM_imgIcono24' src={ic_manual_primary} alt='' style={{cursor:"pointer"}}/> )}/>)}  
                                                    {errorDiasUS[index] && (<img className='IM_imgIcono24' src={ic_transparente} alt='' />)}  
                                                </div>
                                            </div>
                                        )}/>                                          
                                            
                                        )}                                        
                                    </td> 
                                </tr>   
                                ))}
                                
                            </tbody>
                        </table>
                    </div>
                    </DndContext>

                    <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", marginTop:"8px"}}>
                        <img className='IM_imgIcono16' src={ic_manual_primary} alt='' style={{padding:"4px"}}/>
                        <div style={{fontSize:"12px", color:C_uniformeGrisOscuro}}>Arrastre para copiar el horario en otro día</div>
                    </div>

                    {txtErrorUS!=="" && (<div className="TX_error" style={{fontSize:"12px"}}>{txtErrorUS}</div>)}
                    

                </div> 
                </Modal>
            )}

            {isOpenSelHora && (
                <Modal isOpen={isOpenSelHora} closeModal={closeSelHora} imgModal={ic_reloj} titulo={horaIFSelUS===1 ? "Definir Hora Inicial" : "Definir Hora Final"}  isCancelable={true} txtCancelar="" txtAceptar="" >
                
                <div style={{margin:"20px", maxWidth:"250px"}}>
                    <div style={{width:"180px"}}>  
                        
                        <div style={{display:"flex", flexWrap:"nowrap"}}>
                            <div style={{width:"40px", height:"40px"}}></div>
                            <div style={{width:"30px", height:"40px"}}>
                                <div style={{height:"10px"}}></div>
                                <div className={horaSelUS===11 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(11)}}>11</div>
                            </div>
                            <div style={{width:"40px", height:"40px"}}>                            
                                <div className={horaSelUS===12 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(12)}}>12</div>
                                <div style={{height:"10px"}}></div>
                            </div>
                            <div style={{width:"30px", height:"40px"}}>
                                <div style={{height:"10px"}}></div>
                                <div className={horaSelUS===1 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(1)}}>1</div>
                            </div>
                            <div style={{width:"40px", height:"40px"}}></div>
                        </div>
                        
                        <div style={{display:"flex", flexWrap:"nowrap"}}>                        
                            <div style={{width:"40px", height:"30px", display:"flex", flexWrap:"nowrap"}}>
                                <div style={{width:"10px"}}></div>
                                <div className={horaSelUS===10 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(10)}}>10</div>
                            </div>
                            <div style={{width:"30px", height:"30px"}}></div>
                            <div style={{width:"40px", height:"30px", display:"flex", alignItems:"end", justifyContent:"center"}}>
                                <span className={tipoHoraSelUS==="AM" ? ("BF_fondoPrimary") : ("BF_fondolistaspar")} 
                                style={{fontSize:"14px", paddingBlock:"2px", paddingInline:"8px", cursor:"pointer"}}
                                onClick={() => {clickTiempo("AM")}}>AM</span>
                            </div>
                            <div style={{width:"30px", height:"30px"}}></div>
                            <div style={{width:"40px", height:"30px", display:"flex", flexWrap:"nowrap"}}>                            
                                <div className={horaSelUS===2 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(2)}}>2</div>
                                <div style={{width:"10px"}}></div>
                            </div>
                        </div>

                        <div style={{display:"flex", flexWrap:"nowrap"}}>                        
                            <div style={{width:"30px", height:"40px", display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                <div className={horaSelUS===9 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(9)}}>9</div>
                            </div>
                            <div style={{width:"120px", height:"40px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                                <span style={{fontSize:"12px", color:C_colorTextoSinInfo}}>{txtCentralUS}</span>
                            </div>
                            <div style={{width:"30px", height:"40px", display:"flex", flexWrap:"nowrap", alignItems:"center"}}>
                                <div className={horaSelUS===3 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(3)}}>3</div>
                            </div>
                        </div>

                        <div style={{display:"flex", flexWrap:"nowrap"}}>                        
                            <div style={{width:"40px", height:"30px", display:"flex", flexWrap:"nowrap"}}>
                                <div style={{width:"10px"}}></div>
                                <div className={horaSelUS===8 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(8)}}>8</div>
                            </div>
                            <div style={{width:"30px", height:"30px"}}></div>
                            <div style={{width:"40px", height:"30px", display:"flex", alignItems:"baseline", justifyContent:"center"}}>
                                <span className={tipoHoraSelUS==="PM" ? ("BF_fondoPrimary") : ("BF_fondolistaspar")} 
                                style={{fontSize:"14px", paddingBlock:"2px", paddingInline:"8px", cursor:"pointer"}}
                                onClick={() => {clickTiempo("PM")}}>PM</span>
                            </div>
                            <div style={{width:"30px", height:"30px"}}></div>
                            <div style={{width:"40px", height:"30px", display:"flex", flexWrap:"nowrap"}}>                            
                                <div className={horaSelUS===4 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(4)}}>4</div>
                                <div style={{width:"10px"}}></div>
                            </div>
                        </div>

                        <div style={{display:"flex", flexWrap:"nowrap"}}>
                            <div style={{width:"40px", height:"40px"}}></div>
                            <div style={{width:"30px", height:"40px"}}>                            
                                <div className={horaSelUS===7 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(7)}}>7</div>
                                <div style={{height:"10px"}}></div>
                            </div>
                            <div style={{width:"40px", height:"40px"}}>  
                                <div style={{height:"10px"}}></div>                          
                                <div className={horaSelUS===6 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(6)}}>6</div>                
                            </div>
                            <div style={{width:"30px", height:"40px"}}>                            
                                <div className={horaSelUS===5 ? ("IM_fondoRedondeado30_Sel") : ("IM_fondoRedondeado30")} onClick={() => {clickHora(5)}}>5</div>
                                <div style={{height:"10px"}}></div>
                            </div>
                            <div style={{width:"40px", height:"40px"}}></div>
                        </div>                    

                    </div> 

                    <div>
                        <span className="BF_botonBordeAccentFull" style={{margin:"20px", fontSize:"14px"}} onClick={() => {clickHorario("BORRAR_HORA_ACTUAL")}}>Borrar Hora Actual</span>
                    </div>

                    {txtErrorUS!=="" && (<div className="TX_error" style={{fontSize:"12px"}}>{txtErrorUS}</div>)}
                    

                </div>
                </Modal>
            )}
    
    </>
  );
};

export default SelHorario;